/* eslint-disable import/no-cycle */
import axios from 'axios';
import { getItem, removeItem } from '../../utility/localStorageControl';
import { resetAllData } from '../../redux/authentication/actions';
import store from '../../redux/store';

const API_ENDPOINT = `${process.env.REACT_APP_API_ENDPOINT}`;

const authHeader = () => ({
  Authorization: `Bearer ${getItem('access_token')}`,
});

const client = axios.create({
  baseURL: API_ENDPOINT,
  headers: {
    Authorization: `Bearer ${getItem('access_token')}`,
    'Content-Type': 'application/json',
  },
});

class DataService {
  static get(path = '', config = {}) {
    const { headers: configHeaders = {}, ...rest } = config;
    return client({
      method: 'GET',
      url: path,
      headers: { ...authHeader(), ...configHeaders },
      ...rest,
    });
  }

  static post(path = '', data = {}, optionalHeader = {}) {
    const headers = { ...authHeader(), ...optionalHeader };
    // axios 0.x: false removes default JSON Content-Type so FormData gets a proper multipart boundary
    if (typeof FormData !== 'undefined' && data instanceof FormData) {
      headers['Content-Type'] = false;
    }
    return client({
      method: 'POST',
      url: path,
      data,
      headers,
    });
  }

  static patch(path = '', data = {}) {
    return client({
      method: 'PATCH',
      url: path,
      data: JSON.stringify(data),
      headers: { ...authHeader() },
    });
  }

  static put(path = '', data = {}) {
    return client({
      method: 'PUT',
      url: path,
      data: JSON.stringify(data),
      headers: { ...authHeader() },
    });
  }

  static delete(path = '', data = {}) {
    return client({
      method: 'DELETE',
      url: path,
      data: JSON.stringify(data),
      headers: { ...authHeader() },
    });
  }
}

/**
 * axios interceptors runs before and after a request, letting the developer modify req,req more
 * For more details on axios interceptor see https://github.com/axios/axios#interceptors
 */
client.interceptors.request.use((config) => {
  const getLang = localStorage.getItem('setLang');
  const requestConfig = config;
  const { headers } = config;
  const cookieToken = getItem('access_token');
  // Prefer Authorization already set on the request (e.g. fresh token right after password reset)
  const explicitAuth = headers?.Authorization || headers?.authorization;
  const authorization = explicitAuth || (cookieToken ? `Bearer ${cookieToken}` : '');
  requestConfig.headers = { ...headers, Authorization: authorization, lang: getLang || 'ita' };

  // Let the runtime set multipart boundary; default application/json breaks FormData uploads.
  if (typeof FormData !== 'undefined' && requestConfig.data instanceof FormData) {
    delete requestConfig.headers['Content-Type'];
  }

  return requestConfig;
});

client.interceptors.response.use(
  (response) => response,
  (error) => {
    /**
     * Do something in case the response returns an error code [3**, 4**, 5**] etc
     * For example, on token expiration retrieve a new access token, retry a failed request etc
     */
    const { response } = error;
    // const originalRequest = error.config;
    if (response) {
      if (response.status === 500) {
        // do something here
      } else if (response.status === 401 || response.data?.message === 'Unauthenticated.') {
        // clear all when token unauthenticated
        localStorage.clear();
        removeItem('access_token');
        removeItem('logedIn');
        store.reduxStore.dispatch(resetAllData());
        window.location.replace('/');
        // Avoid a second full reload — replace is enough for SPA; reload was doubling navigation and hiding errors.
      } else {
        return response;
      }
    }
    return Promise.reject(error);
  },
);
export { DataService };
